import {Component, EventEmitter, Inject, LOCALE_ID, OnDestroy, OnInit, Output} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {UserService} from '@carm/_core/access-control-mgt/facade/user.service';
import {UserRole} from '@carm/_core/access-control-mgt/models/user-role.model';
import {PublicHeaderService} from '@carm/base-layout/main/public-header.service';
import { applicationFeaturesArray } from '@carm/shared/constants/const-application-features';
import { Observable } from 'rxjs';
import {filter, take, takeUntil} from 'rxjs/operators';
import {GroupTypes} from '../../../../_core/access-control-mgt/models/acl.model';
import {RoutesConst} from '../../../../shared/constants/const-routes';
import {IMenu} from '../models/menu.model';
import { ProgramTypes } from '@carm/_core/access-control-mgt/models';
import { CarmResources } from '@carm/_core/access-control-mgt/models';
import { AccessControlService } from '@carm/_core/access-control-mgt/services';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { MetadataService } from '@carm/_core/metadata/services';
import { BaseComponent } from '@carm/_utils/base.component';
import { AuthService } from '@carm/_auth/spartacus/core/auth';


@Component({
  selector: 'carm-main-header-bottom-section',
  templateUrl: './main-header-bottom-section.component.html',
  styleUrls: ['./main-header-bottom-section.component.scss'],
})
export class MainHeaderBottomSectionComponent extends BaseComponent implements OnInit, OnDestroy {

  @Output() logout = new EventEmitter();

  notificationsRoute = RoutesConst.Notifications_List;
  personalProfile = RoutesConst.AccountProfile_PersonalProfile;

  isLoggedIn$: Observable<boolean>;
  userRole$: Observable<UserRole>;

  headerMenuIsOpen = false;
  setupPortalMenuIsOpen = false;
  privateMenuItems: IMenu[];
  isHidden: boolean;
  locale: string;
  showMenu: boolean;
  showMenuButton: boolean;
  groupType = GroupTypes;
  carmResource = CarmResources;
  isPublic: boolean; // if logged true
  isBrokerOrThirdParty: boolean = false;
  isSetupMyPortalAllowed$: Observable<any[]>;
  setupMyPortalAcl = [{
    acl: [
      {
        resource: CarmResources.PERSONAL_PROFILE,
        group: GroupTypes.Reader,
        isNativeAcl: true,
      },
    {
      resource: CarmResources.EMPLOYEE,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
    {
      resource: CarmResources.MANAGE_RELATIONSHIPS,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
    {
      resource: CarmResources.CLIENT_GROUPS,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
    {
      resource: CarmResources.API,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
    {
      resource: CarmResources.PROGRAM_ENROLMENT,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
    {
      resource: CarmResources.DOA,
      group: GroupTypes.Reader,
      isNativeAcl: true,
    },
    ]
  }];

  constructor(private router: Router,
              private carmRouter: CarmRouter,
              private metadataService: MetadataService,
              private authService: AuthService,
              @Inject(LOCALE_ID) protected localeId: string,
              protected userService: UserService,
              private publicHeaderService: PublicHeaderService,
              protected accessControlService: AccessControlService) {

    super();

    if (localeId === 'en') {
      this.locale = 'en';
    } else if (localeId === 'fr') {
      this.locale = 'fr';
    } else {
      // This case is really only for dev when not defining the local
      this.locale = 'en';
    }

    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd ) {
        this.showMenu = this.publicHeaderService.isLoggedExclusion(event);
        this.showMenuButton = this.publicHeaderService.isMenuButtonDisplayed(event);
        this.isPublic = this.publicHeaderService.publicHeader(event);
      }
    });

    this.privateMenuItems = applicationFeaturesArray();

    let filteredMenuItems = this.privateMenuItems.filter( menuItems => {
      return !menuItems.localizationKey.includes('application_features.homepage')
    })

    this.privateMenuItems = filteredMenuItems;
  }

  ngOnInit() {

    this.isLoggedIn$ = this.authService.isUserLoggedIn().pipe(takeUntil(this.destroy$));
    this.userRole$ = this.userService.getUserRoles().pipe(takeUntil(this.destroy$));
    this.isSetupMyPortalAllowed$ = this.accessControlService.applyAcl(this.setupMyPortalAcl);

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((_) => {
      this.headerMenuIsOpen = false;
      this.setupPortalMenuIsOpen = false;
    });

    this.checkBroker();
  }

  checkBroker() {
    this.userService.getUserLastUsedRole()
      .pipe(takeUntil(this.destroy$))
      .subscribe(e => {
        this.isBrokerOrThirdParty = (e?.program?.programType === ProgramTypes.CustomsBroker || e?.program?.programType === ProgramTypes.ThirdPartyServiceProvider);
      });
  }

  toggleMenu() {
    this.headerMenuIsOpen = !this.headerMenuIsOpen;
  }

  onLogout() {
    this.authService.logout();
    this.userService.logOut();
    this.metadataService.resetMetadata();
    this.authService.isUserLoggedIn().pipe(
      filter((isLoggedIn) => isLoggedIn === false), take(1), takeUntil(this.destroy$))
      .subscribe(() => {
      this.carmRouter.carmNavigate([RoutesConst.Logout]);
    });
  }

  onMenuClick(menu: IMenu) {
    if (menu.sections?.length === 0) {
      this.carmRouter.carmNavigate([menu.path]);
    }
  }
}
